module.exports = __webpack_public_path__ + "img/award-fill.e669864d.svg";